export default __webpack_public_path__ + "static/media/imgpost11.68557963.jpg";